import { DataTable } from 'primereact/datatable';
import React from 'react';
import * as meta from '../../meta-data.json';
import { Feedback } from '../Feedback';
import { IDummyProps } from './types';

export const View = (props: IDummyProps) => {
	const {
		value = [],
		rootref,
		stripped,
		bordered,
		size,
		emptyMessage,
		verticalHeaderAlignment = 'middle',
		verticalCellAligment = 'middle',
		rootClassName,
		...rest
	} = props;
	const _stripped = stripped ? 'p-datatable-striped ' : '';
	const _bordered = bordered ? 'p-datatable-gridlines ' : '';
	const _sizesMap = {
		mini: 'p-datatable-xs',
		compact: 'p-datatable-sm',
		default: '',
		large: 'p-datatable-lg',
	};
	const _size = _sizesMap[size || 'default'];

	const _headerAligment = 'p-datatable-header-' + verticalHeaderAlignment;

	const _cellAligment = 'p-datatable-cell-' + verticalCellAligment;

	const feedbackEmptyMessage = (
		<div style={{ display: 'inline-flex' }}>
			<Feedback closeable={false} displayBlock={true} theme="warning" text={emptyMessage} />
		</div>
	);

	return (
		<div
			data-epo={`epo-data-table-${meta.version}`}
			{...{ part: `epo-data-table-${meta.version}` }}
			className={`epo-data-table-${meta.version} ${rootClassName}`}
		>
			<DataTable
				ref={rootref}
				value={value || []}
				{...rest}
				className={`${_stripped} ${_bordered} ${_size} ${_headerAligment} ${_cellAligment} ${props.className}`}
				emptyMessage={typeof emptyMessage === 'string' ? feedbackEmptyMessage : emptyMessage}
			></DataTable>
		</div>
	);
};
